import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import classNames from 'classnames';
import { bindGa } from 'helpers/analytics';
import s from './EmailPrintFontOptions.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class EmailPrintFontOptions extends React.PureComponent {
  constructor() {
    super();
    this.changeSize = this.changeSize.bind(this);
    this.state = {
      toggleFontDropDown: false,
    };
    this.toggleFontDropDown = this.toggleFontDropDown.bind(this);
  }

  @bindGa({})
  changeSize(e, size) {
    this.props.changeSize(size);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'atfSize',
      label: size,
      category: this.props.isLiveBlog
        ? 'liveblog_sticky'
        : 'articleshow_sticky',
    });
  }

  toggleFontDropDown(event) {
    event.stopPropagation();
    const currToggleFontDropDown = this.state.toggleFontDropDown;
    this.setState({
      toggleFontDropDown: !currToggleFontDropDown,
    });
  }

  closeFontDropDown() {
    const closeFontDropDown = this.state.toggleFontDropDown;
    this.setState({
      toggleFontDropDown: !closeFontDropDown,
    });
  }

  render() {
    const {
      msid,
      textSize,
      gaCategory,
      printLayout,
      isLiveBlog,
      hidePrintOption,
    } = this.props;
    const gaLabel = this.props.gaLabel || '';
    const gaAction = this.props.gaAction || 'print_article';
    const toggleClass = this.state.toggleFontDropDown ? s.active : '';
    return (
      <>
        {!hidePrintOption && <Link
          className={s.print_article}
          href={
            printLayout
              ? `https://timesofindia.indiatimes.com/print_articleshowprint/${msid}.cms`
              : `/articleshowprint/${msid}.cms`
          }
          target="_blank"
          rel="noopener noreferrer"
          title="print article"
          data-ga={`${gaCategory}|${gaAction}|${gaLabel}_print`}
          ga4Data={[
            {
              event: 'user_click',
              type: 'atf_print',
              category: isLiveBlog ? 'liveblog_sticky' : 'articleshow_sticky',
            },
          ]}
        />}

        <div
          className={`${s.fontstyling} ${toggleClass} ${
            hidePrintOption ? s.fonticon_margin : ''
          }`}
        >
          <span onClick={this.toggleFontDropDown}>AA</span>
          <div className={`${s.dropdown}`}>
            <button
              type="button"
              className={s.closeBtn}
              onClick={e => this.closeFontDropDown(e)}
            >
              +
            </button>
            <strong>Text Size</strong>
            <ul>
              <li
                className={classNames({
                  [`${s.active}`]: textSize === 'small',
                })}
                data-ga={`${gaCategory}|${gaAction}|${gaLabel}Size_small`}
                onClick={e => this.changeSize(e, 'small')}
              >
                Small
              </li>
              <li
                className={classNames({
                  [`${s.active}`]: textSize === 'medium',
                })}
                data-ga={`${gaCategory}|${gaAction}|${gaLabel}Size_medium`}
                onClick={e => this.changeSize(e, 'medium')}
              >
                Medium
              </li>
              <li
                className={classNames({
                  [`${s.active}`]: textSize === 'large',
                })}
                data-ga={`${gaCategory}|${gaAction}|${gaLabel}Size_large`}
                onClick={e => this.changeSize(e, 'large')}
              >
                Large
              </li>
            </ul>
          </div>
        </div>
        {/* {this.props.showFontAlterOptions ? (
            <span
              className={s.fontd}
              data-ga={`${gaCategory}-decrease_font|${gaLabel}`}
              onClick={e => this.decreaseFont(e)}
            />
          ) : null}
          {this.props.showFontAlterOptions ? (
            <span
              className={s.fonti}
              data-ga={`${gaCategory}-increase_font|${gaLabel}`}
              onClick={e => this.increaseFont(e)}
            />
          ) : null} */}
      </>
    );
  }
}

EmailPrintFontOptions.propTypes = {
  msid: PropTypes.string.isRequired,
  changeSize: PropTypes.func.isRequired,
  textSize: PropTypes.number.isRequired,
  gaCategory: PropTypes.string,
  gaAction: PropTypes.string,
  gaLabel: PropTypes.string,
  printLayout: PropTypes.bool,
  hidePrintOption: PropTypes.bool,
};

EmailPrintFontOptions.defaultProps = {
  gaCategory: 'extra_controls',
  gaAction: '',
  gaLabel: '',
  printLayout: false,
  hidePrintOption: false,
};

export default EmailPrintFontOptions;
